import React, { Component } from 'react';
import './DrugDetailsPage.css';
import Page from '../../components/page/Page';
import models from '../../model/models';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Button from '../../components/button/Button';
import history from '../../history';
import Volume from '../../components/volume/Volume';
import LabelAndValue from '../../components/labelAndValue/LabelAndValue';
import DiscrepancyPopup from '../../popups/discrepancyPopup/DiscrepancyPopup';
import UpdateDrugPopup from '../../popups/updateDrugPopup/UpdateDrugPopup';
import Map from '../../components/map/Map';
import toasts from '../../utils/toasts';
import mainAPI from '../../api/MainAPI';
import CardHeader from '../../components/cardHeader/CardHeader';
import Row from '../../components/row/Row';
import utils from '../../utils/utils';
import HeaderRow from '../../components/headerRow/HeaderRow';
import DrugHistoryCard from '../../cards/drugHistoryCard/DrugHistoryCard';
import { getDisplayUnit } from '../../utils/gramUtils';
import ImagePopup from '../../popups/imagePopup/ImagePopup';
import Image from '../../components/image/Image';

export default class DrugDetailsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			codeError: false,
			codeTouched: false,
			update: false,
			drug: {},
			updatedDrug: {
				type: null,
				barcode_id: null,
				drug_box_id: null,
				lot_number: null,
				expiration_date: null,
				amount: null
			},
			canDelete: false,
			drugOrderForm: null,
			inventoryChecks: null,
			user_group: null
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.drug.onChange(this._getDrugData);
		this.userGroupSubId = models.user_group.onChange(this._getUserGroup);
		this._getUserGroup();
	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.subscribeId);
		models.user_group.unsubscribe(this.userGroupSubId);
	};

	_getUserGroup = () => {
		let user_group = models.user_group.obj();
		if (user_group) {
			this.setState({ user_group });
		}
	};

	_getDrugData = async () => {
		const {match: {params: {id} = {}} = {}} = this.props;
		const {canDelete} = await mainAPI.drug.canDelete(id) || {};

		let drug = await mainAPI.drug.get(id);
		if (drug) {
			drug.stock_move_record__quantity = Volume.inPreferredUnit(drug.stock_move_record__quantity, drug.type);
			this.myRefs = { ...drug };
			this.setState({
				drug,
				updatedDrug: drug,
				canDelete
			});

			if (drug.drug_order_form_id) {
				this._getDrugOrderForm(drug.drug_order_form_id);
			}
		}
		await this._getTransferData();
		await this._getInventoryChecks(drug);
	};

	_getDrugOrderForm = async (drugOrderFormId) => {
		try {
			const form = await mainAPI.drug_order_form.get(drugOrderFormId);
			if (form) {
				this.setState({ drugOrderForm: form });
			}
		} catch (error) {
			console.error('Error fetching drug order form:', error);
		}
	};

	_navigateToDrugOrderForm = () => {
		const { drug: { drug_order_form_id } = {} } = this.state;
		if (drug_order_form_id) {
			history.navigate('/drug-order-form/' + drug_order_form_id);
		}
	};

	_getTransferData = async () => {
		const id = this.props.match.params.id;
		let transfers = await mainAPI.drug_transfer.for_drug(id);
		this.setState({ transfers });
	};

	_getInventoryChecks = async (drug) => {
		if (!drug || !drug.id) return;
		let inventoryChecks = await mainAPI.drug_check.paginated({ drug_id: drug.id, limit: 10 });
		this.setState({ inventoryChecks });
	};

	_showDeleteModal = () => {
		window.popupController.show(DiscrepancyPopup, {
			title: 'Are you sure you want to delete this drug?',
			notesPlaceholder: 'Why are you removing this?',
			onComplete: this._deleteDrug,
			id: this.props.match.params.id
		});
	};

	_deleteDrug = async (drug) => {
		models.drug.delete(drug.id, drug.notes).then((success) => {
			if (!success) toasts.show('Could not delete drug', 5000);
		});
		window.popupController.hide(DiscrepancyPopup);
		history.navigate('/drugs');
		return true;
	};

	_showUpdateModal = () => {
		window.popupController.show(UpdateDrugPopup, { drug: this.state.drug });
	};

	_renderMap = () => {
		return null;
		// eslint-disable-next-line no-unreachable
		let practiceCoords = [
			{ lat: 40.249999, lng: -111.6499974 },
			{ lat: 40.248999, lng: -111.6449974 },
			{ lat: 40.247999, lng: -111.6459974 },
			{ lat: 40.245999, lng: -111.6479974 }
		];
		return (
			<Card className="g-drug-details-page-content-component-map">
				<div className="g-drug-details-page-header">
					<Label black large className="g-drug-details-page-content-header">
						Drug Map History
					</Label>
				</div>
				<div className="g-drug-details-page-content">
					<Map coords={practiceCoords} />
				</div>
			</Card>
		);
	};
	renderTransferList = () => {
		let transfers = this.state.transfers;
		if (!transfers) return null;
		let columns = [
			{ label: 'Transferred by' },
			{ label: 'Transferred on' },
			{ label: 'From box' },
			{ label: 'To box' }
		];
		let display = [<HeaderRow key={'headers'} columns={columns} />];
		for (let i in transfers) {
			display.push(
				<Row key={i + transfers[i].id + transfers[i].user_name}>
					<Label> {transfers[i].user_name}</Label>
					<Label> {utils.display_actual_datetime(transfers[i].created_on)}</Label>
					<Label> {transfers[i].from_box_name}</Label>
					<Label> {transfers[i].to_box_name}</Label>
				</Row>
			);
		}
		return display;
	};

	showImagePopup = (src) => {
		window.popupController.show(ImagePopup, { src, token: localStorage.token });
	};

	renderInventoryChecks = () => {
		let inventoryChecks = this.state.inventoryChecks;
		let user_group = this.state.user_group;
		let allowImageUpload = user_group && user_group.allow_image_upload;

		if (!inventoryChecks || inventoryChecks.length === 0) return <Label className={'no-inventory-checks'}>No inventory checks found.</Label>;

		let columns = [
			{ label: 'Checked by' },
			{ label: 'Checked on' },
			{ label: 'Resealed Code' }
		];
		if (allowImageUpload) {
			columns.push({ label: '' });
		}

		let display = [<HeaderRow key="headers" columns={columns} />];
		for (let i in inventoryChecks) {
			const fullUrl = mainAPI.rootURL() + inventoryChecks[i].image_url;
			const otherProps = {};

			let imageColumn = null;
			if (allowImageUpload) {
				imageColumn = inventoryChecks[i].image_url
					? <Image src={fullUrl} headers={{ 'x-auth-token': localStorage.token }} />
					: <div></div>;
				if (inventoryChecks[i].image_url) {
					otherProps.onClick = () => this.showImagePopup(fullUrl);
				}
			}

			display.push(
				<Row key={i + inventoryChecks[i].id} className={allowImageUpload ? 'image-row' : ''} {...otherProps}>
					<Label>{inventoryChecks[i].user__first_name + ' ' + inventoryChecks[i].user__last_name}</Label>
					<Label>{utils.display_actual_datetime(inventoryChecks[i].created_on)}</Label>
					<Label>{inventoryChecks[i].reseal_box_barcode_id || '-'}</Label>
					{imageColumn}
				</Row>
			);
		}
		return display;
	};

	render() {
		const deleteButton = () => {
			const {canDelete = false} = this.state;
			if (!canDelete) return null;
			return (<Button
				className="g-drug-details-page-delete-button"
				color="white"
				bg="red"
				onClick={this._showDeleteModal}
			>Delete</Button>);
		}

		const {
			update,
			drug: {
				id,
				barcode_id = '-',
				expiration_date,
				short_date,
				last_checked_on,
				stock_move_record__quantity = '-',
				lot_number,
				ndc_barcode,
				drug_box__name,
				type = '-',
			} = {},
			drugOrderForm
		} = this.state;
		const drugType = models.drug_type.obj(type) || '';
		return (
			<Page className="g-drug-details-page">
				{update && this._renderUpdateModal()}
				<Card className="g-drug-details-page-content-component">
					<div className="g-drug-details-page-header">
						<CardHeader>Drug Details</CardHeader>
						<div className="g-drug-details-page-buttons">
							<Button
								className="g-drug-details-page-delete-button"
								color="white"
								bg="blue"
								onClick={this._showUpdateModal}
							>
								Edit
							</Button>
							{ deleteButton() }
						</div>
					</div>
					<div className="g-drug-details-page-content">
						<div className="g-drug-details-page-content-left">
							<LabelAndValue label="Type" value={drugType.name || utils.capitalize(type).replace(/_/g, ' ')} />
							<LabelAndValue label="Code" value={barcode_id} />
							<LabelAndValue label="Drug Box" value={drug_box__name} />
							<LabelAndValue label="Volume" value={stock_move_record__quantity + ' ' + getDisplayUnit(type)} />
						</div>
						<div className="g-drug-details-page-content-right">
							<LabelAndValue
								key="Last" label="Last Check"
								value={last_checked_on ? utils.display_actual_datetime(last_checked_on) : '-'}
							/>
							<LabelAndValue key="Lot" label="Lot Number" value={lot_number} />
							<LabelAndValue key="Expiration" label="Expiration" value={expiration_date ? utils.display_date(expiration_date) : '-'} />
							{short_date &&<LabelAndValue key={'short_date'} label="Short Date" value={short_date ? utils.display_date(short_date) : '-'} />}
							{ndc_barcode && <LabelAndValue key={'ndc'} label="NDC Barcode" value={ndc_barcode} />}

							<LabelAndValue
								key={'drug_order_form'}
								label="Drug Order Form"
								value={
									drugOrderForm ? (
										<Label
											onClick={this._navigateToDrugOrderForm}
											blue
											style={{ textDecoration: 'underline', cursor: 'pointer' }}
										>
											{drugOrderForm.form_number}
										</Label>
									) : (
										'-'
									)
								}
							/>
						</div>
					</div>
				</Card>
				{this._renderMap()}
				<Card className="transfers">
					<CardHeader>Box Transfers</CardHeader>
					{this.renderTransferList()}
				</Card>
				<Card className="inventory-checks">
					<CardHeader>Recent Inventory Checks</CardHeader>
					{this.renderInventoryChecks()}
				</Card>
				<DrugHistoryCard drugId={id} type={type} />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugDetailsPage/DrugDetailsPage.jsx